import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApiResponse } from '@shared/models/api-response.model';
import { BankAccount } from '@shared/models/bank-account.model';


@Injectable({
  providedIn: 'root'
})
export class BankAccountDataService {

  messages$ = new Subject<any[]>();
  isSuccess: boolean;

  constructor(private http: HttpClient) { }

  getAll(): Observable<BankAccount[]>{
    return this.http.get<ApiResponse>(`/bankaccount`).pipe(
      map(res => res.data.rows)
    );
  }


  getWithQuery(pageParam: string): Observable<BankAccount[]>{
    return this.http.get<ApiResponse>(`/bankaccount${pageParam}`).pipe(
      map(res => res.data.rows)
    );
  }

  addBank(bankAccount: BankAccount){
    return this.http.post<ApiResponse>(`/bankaccount`, bankAccount).pipe(
      map( res => {
        this.messages$.next(res.message);
        this.isSuccess = res.success;
      })
    );
  }

  deleteBank(bankAccountId: number): Observable<BankAccount>{
    return this.http.delete<ApiResponse>(`/bankaccount/${bankAccountId}`).pipe(
      tap((res: any) => {
        this.messages$.next(res.message);
        this.isSuccess = res.success;
      })
    );
  }

}
